<template>
  <div class="inline-flex relative dropdown account" @click.self="gotoIcon" @keyup.enter="gotoIcon"
       :class="{active: active}"
       data-testid="accountButton" tabindex="0" role="button"
       :aria-label="$t('Open my account')"
       @mouseenter="isDesktop ? active = true : null"
       @mouseleave="isDesktop ? active = false : null"
  >
    <button type="button" class="flex bg-cl-transparent brdr-none" style="margin: 14px; padding: 1px;">
      <img class="dropdown-img" src="../../../../assets/icons/icon-account.svg" alt="account" width="22" height="22" loading="eager" fetchpriority="high">
    </button>
    <div
      v-show="currentUser"
      class="dropdown-content bg-cl-primary align-left sans-serif lh20 weight-400"
      :class="{'left-account': isHomepage, 'right-account': !isHomepage}"
    >
      <div
        class="dropdown-overlay"
        @click.self.stop="active = false"
      />
      <div class="py5">
        <div v-for="(page, index) in navigation" :key="index" @click="handleLinkClick(page.title)">
          <router-link class="no-underline block py10 px15" :to="localizedRoute(page.link)">
            {{ $t(page.title) }}
          </router-link>
        </div>
      </div>
      <div class="py5 brdr-top-1 brdr-cl-bg-secondary">
        <a href="#" class="no-underline block py10 px15" @click.prevent="logout">
          {{ $t('Logout') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import NoSSR from 'vue-no-ssr'
import AccountIcon from '@vue-storefront/core/compatibility/components/blocks/Header/AccountIcon'
import windowResize from '@vue-storefront/core/mixins/windowResize';
import { isServer } from '@vue-storefront/core/helpers'

export default {
  mixins: [AccountIcon, windowResize],
  components: {
    'no-ssr': NoSSR
  },
  props: {
    fixedHeader: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      active: false,
      navigation: [
        { title: 'My profile', link: '/my-account' },
        { title: 'Change password', link: '/my-account/password' },
        { title: 'Delivery address', link: '/my-account/shipping-details' },
        { title: 'My payment details', link: '/my-account/payment-details' },
        { title: 'My orders', link: '/my-account/orders' }
        // { title: this.$t('My Recently viewed products'), link: '/my-account/recently-viewed' }
      ]
    }
  },
  computed: {
    isHomepage () {
      return this.$route.name === 'home'
    },
    getCurrentDevice () {
      if (!isServer) {
        if (!this.getStandaloneStatus) {
          return (/iphone/i.test(navigator.userAgent.toLowerCase()) && /safari/i.test(navigator.userAgent.toLowerCase()) && !/crios/i.test(navigator.userAgent.toLowerCase()))
            ? 'iphone'
            : (/android/i.test(navigator.userAgent.toLowerCase()) && /chrome/i.test(navigator.userAgent.toLowerCase()))
              ? 'android'
              : false
        } else {
          return false
        }
      }
    },
    getStandaloneStatus () {
      return window.matchMedia('(display-mode: standalone)').matches
    },
    isDesktop () {
      return this.windowWidth > 768
    }
  },
  methods: {
    gotoIcon () {
      if (this.isLoggedIn) {
        if (!this.isDesktop) this.active = !this.active;
      } else {
        this.goToAccount()
      }

      if (this.windowWidth < 991) {
        this.$bus.$emit('hide-burger-menu')
        this.$bus.$emit('close-burger')
        this.$bus.$emit('hide-overlay-in-shop')
        this.$bus.$emit('change-close-btn')
      }
    },
    handleLinkClick (title) {
      this.active = false;
      this.notify(title);
    },
    notify (title) {
      if (title === 'My loyalty card' || title === 'My product reviews') {
        this.$store.dispatch('notification/spawnNotification', {
          type: 'warning',
          message: this.$t('This feature is not implemented yet! Please take a look at https://github.com/DivanteLtd/vue-storefront/issues for our Roadmap!'),
          action1: { label: this.$t('OK') }
        })
      }
    }
  },
  watch: {
    fixedHeader () {
      if (this.fixedHeader && this.active) this.active = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-icon-hover: color(secondary, $colors-background);

.dropdown {
  background-color: white;
  outline: none;
  cursor: pointer;

  &.right-side .dropdown-content {
    right: 0;
  }

  &.left-side .dropdown-content {
    left: 0;
  }

  &-img {
    width: 22px;
    height: 22px;
  }

  button {
    pointer-events: none;
  }

  a, .icon {
    opacity: 1;

    &:hover,
    &:focus {
      background-color: $color-icon-hover;
      opacity: 1;
    }

  }

  .dropdown-overlay {
    @media only screen and (max-width: 768px) {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: none;
      cursor: default;
    }
  }

  .dropdown-content {
    width: 160px;

    position: absolute;
    top: 100%;
    display: none;

    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    z-index: 1;
  }

  &.active {
    background-color: $color-icon-hover;

    .dropdown-overlay,
    .dropdown-content {
      display: block;
    }
  }
}
</style>
